export default {
    notFound: {
        name: 'Demo_Document_NotFound.pdf',
        hash: '0x8db3dfe7de59e35f5f8be5fde6da543b57ccc017388def7c0a1db7af24db4abf',
        issuerAddress: null,
        issuerName: null,
        issuerImg: null,
        issuerVerified: false,
        revoked: false,
        expiry: null,
        loaded: true
    },
    technicalProblem: {
        name: 'Demo_Document_TechnicalProblem.pdf',
        hash: '0x8db3dfe7de59e35f5f8be5fde6da543b57ccc017388def7c0a1db7af24db4abf',
        issuerAddress: null,
        issuerName: null,
        issuerImg: null,
        issuerVerified: false,
        revoked: false,
        expiry: null,
        loaded: true,
        offchainError: true
    },
    verifiedProcessing: {
        hashed: true,
        name: 'Demo_Document_Verified_Processing.pdf',
        hash: '0x33e63485a8594ee7d1cfbb418a6f5acf7532faca38aa8a36b23eec8f6a53d179',
        on_blockchain: false,
        issuerAddress: undefined,
        issuerName: 'Demo University',
        issuerImg: null,
        issuerVerified: true,
        revoked: false,
        expiry: undefined,
        status: 'registering',
        loaded: true
    },
    verified: {
        hashed: true,
        name: 'Demo_Document_Verified.pdf',
        hash: '0x33e63485a8594ee7d1cfbb418a6f5acf7532faca38aa8a36b23eec8f6a53d179',
        on_blockchain: true,
        issuerAddress: '0xD0f6C73Bf87d1A00797A8A1DF2dF0Dad89D2411f',
        issuerName: 'Demo University',
        issuerImg: null,
        issuerVerified: true,
        revoked: false,
        expiry: null,
        registrationEvent: {
            address: '0x5ee4ec3cbee909050e68c7ff7a8b422cfbd72244',
            blockHash: '0xa95f5fce5e6ebfcbdb8bbd932e412fd376dc8b7189b8d8572fe9d4d8994961de',
            blockNumber: 7937331,
            transactionHash: '0x9b7e8f75ae271d8d659eb7bbd6d090fad3c784f862a5a83368fbc970bfa0a215 ',
            event: 'FileRegisteredEvent',
            signature: '0x98b03391b6b42a1d067881e3d2a22b2091e0412a0e2c40cf687d1c036beb6e11'
        },
        registrationBlock: {
            hash: '0x9b7e8f75ae271d8d659eb7bbd6d090fad3c784f862a5a83368fbc970bfa0a215',
            timestamp: 1560246087
        },
        loaded: true
    },
    verifiedSelfDeclared: {
        hashed: true,
        name: 'Demo_Document_Verified_Self_Declared.pdf',
        hash: '0x33e63485a8594ee7d1cfbb418a6f5acf7532faca38aa8a36b23eec8f6a53d179',
        on_blockchain: true,
        issuerAddress: '0xD0f6C73Bf87d1A00797A8A1DF2dF0Dad89D2411f',
        issuerName: 'Demo University',
        issuerImg: null,
        issuerVerified: false,
        revoked: false,
        expiry: null,
        registrationEvent: {
            address: '0x5ee4ec3cbee909050e68c7ff7a8b422cfbd72244',
            blockHash: '0xa95f5fce5e6ebfcbdb8bbd932e412fd376dc8b7189b8d8572fe9d4d8994961de',
            blockNumber: 7937331,
            transactionHash: '0x9b7e8f75ae271d8d659eb7bbd6d090fad3c784f862a5a83368fbc970bfa0a215 ',
            event: 'FileRegisteredEvent',
            signature: '0x98b03391b6b42a1d067881e3d2a22b2091e0412a0e2c40cf687d1c036beb6e11'
        },
        registrationBlock: {
            hash: '0x9b7e8f75ae271d8d659eb7bbd6d090fad3c784f862a5a83368fbc970bfa0a215',
            timestamp: 1560246087
        },
        loaded: true
    },
    revokedVerified: {
        hashed: true,
        name: 'Demo_Document_RevokedVerified.pdf',
        hash: '0x33e63485a8594ee7d1cfbb418a6f5acf7532faca38aa8a36b23eec8f6a53d179',
        on_blockchain: true,
        issuerAddress: '0xD0f6C73Bf87d1A00797A8A1DF2dF0Dad89D2411f',
        issuerName: 'Demo University',
        issuerImg: null,
        issuerVerified: true,
        revoked: true,
        expiry: null,
        registrationEvent: {
            address: '0x5ee4ec3cbee909050e68c7ff7a8b422cfbd72244',
            blockHash: '0xa95f5fce5e6ebfcbdb8bbd932e412fd376dc8b7189b8d8572fe9d4d8994961de',
            blockNumber: 7937331,
            transactionHash: '0x9b7e8f75ae271d8d659eb7bbd6d090fad3c784f862a5a83368fbc970bfa0a215',
            event: 'FileRegisteredEvent',
            signature: '0x98b03391b6b42a1d067881e3d2a22b2091e0412a0e2c40cf687d1c036beb6e11'
        },
        registrationBlock: {
            hash: '0x9b7e8f75ae271d8d659eb7bbd6d090fad3c784f862a5a83368fbc970bfa0a215',
            timestamp: 1560246087
        },
        revocationEvent: {
            address: '0x5ee4ec3cbee909050e68c7ff7a8b422cfbd72244',
            blockHash: '0xa95f5fce5e6ebfcbdb8bbd932e412fd376dc8b7189b8d8572fe9d4d8994961de',
            blockNumber: 7937331,
            transactionHash: '0x9b7e8f75ae271d8d659eb7bbd6d090fad3c784f862a5a83368fbc970bfa0a215',
            event: 'FileRegisteredEvent',
            signature: '0x98b03391b6b42a1d067881e3d2a22b2091e0412a0e2c40cf687d1c036beb6e11'
        },
        revocationBlock: {
            hash: '0x9b7e8f75ae271d8d659eb7bbd6d090fad3c784f862a5a83368fbc970bfa0a215',
            timestamp: 1560346087
        },
        loaded: true
    }
}
